import React, { useEffect, useRef } from "react";
import Header from "../layout/Header";
import { default as Ratings } from "../ratings";
import { default as Questions } from "../questions";
import Feedback from "../feedback";
import Success from "../success";
import { appConstants } from "../../utils/constants";
import "../../assets/css/dashboard.css";
import i18n from "../i18n";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useDashboardContext } from "../../context/customhook/dashboardHook";
import { useTokenContext } from "../../context/customhook/tokenHook";
import { default as DynamicQuestion } from "../dynamic/DynamicQuestions";

export default function Dahboard() {
  //to move bottom when all questions answered for submit
  const bottomRef = useRef(null);
  const { dashboardStates } = useDashboardContext();
  const { isLoading } = useTokenContext();

  useEffect(() => {
    if (
      dashboardStates?.showAdditionalFeedback ||
      !dashboardStates?.childQuestionId
    ) {
      // 👇️ scroll to bottom when sub-questions are selected
      bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [
    dashboardStates?.showAdditionalFeedback,
    dashboardStates?.childQuestionId,
  ]);

  useEffect(() => {
    //setting Default Language English
    localStorage.setItem(appConstants.language, appConstants.en);
    i18n.changeLanguage(appConstants.en);
  }, []);

  return (
    <div>
      <div>
        <div dir={dashboardStates?.pageDirection}>
          <Header />
          {!dashboardStates?.isSubmitted ? (
            <div className="content-background">
              {isLoading || dashboardStates?.isSubmitloading ? (
                <Skeleton
                  height={10}
                  count={dashboardStates?.isSubmitloading ? 2 : 1}
                />
              ) : (
                <>
                  <Ratings />
                  {/* <Questions /> */}
                  <DynamicQuestion />
                  {dashboardStates?.showAdditionalFeedback ? (
                    <Feedback />
                  ) : null}
                </>
              )}
            </div>
          ) : (
            <div className="content-error-background">
              <Success />
            </div>
          )}
        </div>
        <div ref={bottomRef} />
      </div>
    </div>
  );
}
